define(
    'NVT.SSO.Services.View',
    [
        'Backbone',
        'nvt_sso_services.tpl'
    ],
    function (
        Backbone,
        sso_tpl
    ) {
        'use strict';

        return Backbone.View.extend({
            template: sso_tpl,

            getContext: function () {
                return {
                    services: this.options.services || []
                };
            },
        });
    }
);
